import { updateRow } from '@actions/batch-actions';

import {
  DATA_DETAIL_UPDATE_FIELD,
  DATA_DETAIL_CREATE_SEGMENT,
  DATA_DETAIL_SWAP_FIELDS,
  DATA_DETAIL_CLEAR_SCHEDULE,
  DATA_DETAIL_CLONE_SEGMENT,
  DATA_DETAIL_DELETE_SEGMENT,
  DATA_DETAIL_SEGMENT_UPDATE_FIELD,
  DATA_DETAIL_SEGMENT_UPDATE,
  DATA_DETAIL_COMPUTE_SEGMENT_START,
  DATA_DETAIL_COMPUTE_SEGMENT_SUCCESS,
  DATA_DETAIL_ERROR_FIELD,
  DATA_DETAIL_COMPUTE_SEGMENT_ERROR,
  DATA_DETAIL_UPDATE_POLYGON
} from '@constants/action-types';

const actionTypes = new Set([
  DATA_DETAIL_UPDATE_FIELD,
  DATA_DETAIL_CREATE_SEGMENT,
  DATA_DETAIL_SWAP_FIELDS,
  DATA_DETAIL_CLEAR_SCHEDULE,
  DATA_DETAIL_CLONE_SEGMENT,
  DATA_DETAIL_DELETE_SEGMENT,
  DATA_DETAIL_SEGMENT_UPDATE_FIELD,
  DATA_DETAIL_SEGMENT_UPDATE,
  DATA_DETAIL_COMPUTE_SEGMENT_START,
  DATA_DETAIL_COMPUTE_SEGMENT_SUCCESS,
  DATA_DETAIL_ERROR_FIELD,
  DATA_DETAIL_COMPUTE_SEGMENT_ERROR,
  DATA_DETAIL_UPDATE_POLYGON
]);

import { getBatchRow } from '@selectors/batch-edit-selector';

// Sync dataDetails changes to batch edit entry in the store.
export const batchEditSyncMiddleware = store => next => action => {
  const result = next(action);  // Let the action update dataDetails first.

  if (actionTypes.has(action.type)) {
    const state = store.getState();
    const { pathname } = state.router.location;

    if (pathname.startsWith('/batch-upload-edit/')) {
      // e.g., ['batch-upload-edit', 'f985e3fa-a756-46b6-96f0-330c1ebb9c6e', 'non_grouped_row_2']
      const parts = pathname.split('/').filter(part => part);
      const fileId = parts[1];  // 'f985e3fa-a756-46b6-96f0-330c1ebb9c6e'
      const rowId = parts[2];   // 'non_grouped_row_2'

      if (!fileId || !rowId) {
        return result;
      }

      // Get updated data/errors from dataDetails.
      const updatedData = state.dataDetail.data;
      const updatedErrors = state.dataDetail.error;

      // Sync for batch edit:
      const existingRow = getBatchRow(state, fileId, rowId);
      if (existingRow) {
        store.dispatch(updateRow({
          fileId,
          rowId,
          updates: updatedData,
          errors: updatedErrors
        }));
      }
    }
  }

  return result;
};
